import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useSite } from "@/context/SiteContext";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function PageHero({ eyebrow, title, subtitle, image, children }) {
  return (
    <section className="relative overflow-hidden border-b border-[#27272A] bg-black">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
        </>
      )}
      <div className="relative mx-auto max-w-[1400px] px-4 py-20 lg:px-8 lg:py-28">
        {eyebrow && <div className="label-eyebrow mb-4 text-[#FF5500]">{eyebrow}</div>}
        <h1 className="font-heading max-w-3xl text-4xl font-black leading-[1.05] text-white sm:text-5xl lg:text-6xl">{title}</h1>
        {subtitle && <p className="mt-6 max-w-2xl text-base text-[#A1A1AA] md:text-lg">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}

export function CTABand({ title = "Pronto para especificar sua solução?", text = "Envie sua aplicação e receba dimensionamento e proposta da nossa engenharia." }) {
  const { openQuote } = useSite();
  return (
    <section className="border-y border-[#27272A] bg-[#151618]">
      <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-6 px-4 py-16 lg:flex-row lg:items-center lg:px-8">
        <div>
          <h2 className="font-heading text-2xl font-bold text-white md:text-3xl">{title}</h2>
          <p className="mt-2 max-w-xl text-[#A1A1AA]">{text}</p>
        </div>
        <Button data-testid="ctaband-quote-button" onClick={() => openQuote()} className="shrink-0 rounded-none bg-[#FF5500] px-8 py-6 text-base font-bold hover:bg-[#CC4400]">
          Solicitar Orçamento
        </Button>
      </div>
    </section>
  );
}

export function SectionHead({ eyebrow, title, sub }) {
  return (
    <div className="mb-10 max-w-2xl">
      {eyebrow && <div className="label-eyebrow mb-3 text-[#FF5500]">{eyebrow}</div>}
      <h2 className="font-heading text-3xl font-bold text-white md:text-4xl">{title}</h2>
      {sub && <p className="mt-4 text-[#A1A1AA]">{sub}</p>}
    </div>
  );
}
